import { Paper } from '@mui/material';
import React from 'react';
import { FuturePricesList } from 'src/entities/future-price';

interface Props {}

export const FuturePricesPage: React.FunctionComponent<Props> = ({}) => {
  return (
    <div>
      <Paper>
        <FuturePricesList />
      </Paper>
    </div>
  );
};
